import React, { useState, useEffect, useRef, useContext } from "react";
import { IoSearch, IoClose } from "react-icons/io5";
import { FaUserCircle } from "react-icons/fa";
import { BiSolidCart } from "react-icons/bi";
import { LuArrowDownWideNarrow } from "react-icons/lu";
import { DiDropbox } from "react-icons/di";
import { RxHamburgerMenu } from "react-icons/rx";
import Headroom from "react-headroom";
import MyContext from "../MyContext/MyContext";

export default function HeaderOne() {
  const { data, navigate, cart, token, logout } = useContext(MyContext);

  const [flip, setFlip] = useState(false);
  const [menuOpen, setMenuOpen] = useState(false);
  const [mobileMenu, setMobileMenu] = useState(false);
  const [searchValue, setSearchValue] = useState("");
  const [matches, setMatches] = useState([]);

  const menuRef = useRef(null);
  const sidebarRef = useRef(null);

  // Close account dropdown on outside click
  useEffect(() => {
    const handler = (e) => {
      if (menuRef.current && !menuRef.current.contains(e.target)) {
        setMenuOpen(false);
      }
    };
    document.addEventListener("mousedown", handler);
    return () => document.removeEventListener("mousedown", handler);
  }, []);

  // Close sidebar on outside click
  useEffect(() => {
    const handler = (e) => {
      if (mobileMenu && sidebarRef.current && !sidebarRef.current.contains(e.target)) {
        setMobileMenu(false);
      }
    };
    document.addEventListener("mousedown", handler);
    return () => document.removeEventListener("mousedown", handler);
  }, [mobileMenu]);

  // Disable body scroll when sidebar is open
  useEffect(() => {
    document.body.style.overflow = mobileMenu ? "hidden" : "auto";
  }, [mobileMenu]);

  // Live search
  useEffect(() => {
    if (!searchValue.trim()) {
      setMatches([]);
      return;
    }

    const results = [];
    data.forEach((cat) =>
      cat.products.forEach((p) => {
        if (p.title.toLowerCase().includes(searchValue.toLowerCase())) {
          results.push({
            id: p.id,
            title: p.title,
            image: p.image,
            category_route: cat.routing_category,
          });
        }
      })
    );

    setMatches(results);
  }, [searchValue, data]);

  return (
    <Headroom
      pinStart={80}          // start hiding after some scroll
      upTolerance={10}
      downTolerance={10}
      style={{ zIndex: 9999 }} 
    >
      <header className="ultimate-header" >
        <div className={`header-card ${flip ? "flipped" : ""}`}>

          {/* FRONT */}
          <div className="header-front">

            {/* LEFT — LOGO */}
            <div className="left-section">
              <img
                src="/assets/images/logo/logo1.png"
                className="ultimate-logo desktop-logo"
                onClick={() => navigate("/")}
                alt=""
              />

              <img
                src="/assets/images/logo/loader.png"
                className="ultimate-logo mobile-logo"
                onClick={() => navigate("/")}
                alt=""
              />
            </div>

            {/* CENTER */}
            <div className="center-section">
              <nav className="ultimate-nav">
                <li onClick={() => navigate("/")}>Home</li>
                <li onClick={() => navigate("/shop")}>Shop</li>
                <li onClick={() => navigate("/contact")}>Contact</li>
              </nav>
            </div>

            {/* RIGHT ICONS */}
            <div className="right-section">
              <span className="icon-btn" onClick={() => setFlip(true)}>
                <IoSearch />
              </span>

              {/* ACCOUNT AREA */}
              <div className="user-area" ref={menuRef}>
                {!token && (
                  <span className="icon-btn" onClick={() => navigate("/account")}>
                    <FaUserCircle />
                  </span>
                )}

                {token && (
                  <>
                    <div
                      className="user-button"
                      onClick={() => setMenuOpen(!menuOpen)}
                    >
                      <LuArrowDownWideNarrow
                        className={`user-arrow ${menuOpen ? "rot" : ""}`}
                      />
                    </div>

                    {menuOpen && (
                      <div className="user-dropdown">
                        <button onClick={() => navigate("/orders")}>
                          <DiDropbox className="u-icon" /> Orders
                        </button>
                        <button onClick={logout}>
                          <IoClose className="u-icon" /> Logout
                        </button>
                      </div>
                    )}
                  </>
                )}
              </div>

              {/* CART */}
              <div className="cart-btn" onClick={() => navigate("/cart")}>
                <BiSolidCart />
                {cart && cart.length > 0 && (
                  <span className="cart-num">{cart.length}</span>
                )}
              </div>

              {/* MOBILE MENU */}
              <span
                className="icon-btn mobile-burger"
                onClick={() => setMobileMenu(true)}
              >
                <RxHamburgerMenu />
              </span>
            </div>
          </div>

          {/* BACK — SEARCH */}
          <div className="header-back">
            <div className="search-area">
              <input
                type="text"
                placeholder="Search products..."
                value={searchValue}
                onChange={(e) => setSearchValue(e.target.value)}
              />

              {matches.length > 0 && (
                <ul className="search-results">
                  {matches.map((item) => (
                    <li
                      key={item.id}
                      onClick={() => {
                        navigate(`/shop/${item.category_route}/${item.id}`);
                        setFlip(false);
                        setSearchValue("");
                        setMatches([]);
                      }}
                    >
                      <img src={item.image} alt="" />
                      <span>{item.title}</span>
                    </li>
                  ))}
                </ul>
              )}
            </div>

            <span className="icon-btn" onClick={() => setFlip(false)}>
              <IoClose />
            </span>
          </div>
        </div>

        {/* MOBILE SIDEBAR */}
        {mobileMenu && (
          <div className="mobile-sidebar-overlay">
            <div className="mobile-sidebar" ref={sidebarRef}>
              <span className="close-sidebar" onClick={() => setMobileMenu(false)}>
                <IoClose />
              </span>

              <h3>Menu</h3>

              <ul>
                <li onClick={() => navigate("/")}>Home</li>
                <li onClick={() => navigate("/shop")}>Shop</li>
                <li onClick={() => navigate("/contact")}>Contact</li>

                {!token && <li onClick={() => navigate("/account")}>Login</li>}

                {token && (
                  <>
                    <li onClick={() => navigate("/profile")}>Account</li>
                    <li onClick={() => navigate("/orders")}>Orders</li>
                    <li onClick={logout}>Logout</li>
                  </>
                )}
              </ul>
            </div>
          </div>
        )}
      </header>
    </Headroom>
  );
}
